/**
 * Резолвер резервного URL картинки. Если `src` лежит на основном хосте картинок
 * (`primary` = environment.serverPicturesPath), возвращает тот же путь на резервном
 * хосте (`fallback` = environment.serverPicturesPathFallback); иначе `null`
 * (картинка не с хоста картинок, либо резерв не задан).
 *
 * Чистая функция без DOM/Angular — покрыта node-env спеком. Реальную повторную
 * загрузку (перестановку `img.src`) делает {@link ImageFallbackService}.
 */
export function resolvePictureFallback(src: string, primary: string, fallback: string): string | null {
  if (!src || !primary || !fallback) {
    return null;
  }
  if (!src.startsWith(primary)) {
    return null;
  }
  return fallback + src.slice(primary.length);
}
